<template id="cmsForm">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item">
          <a href="/product_page">Product Page</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Product Page form
        </li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-10">
        <h3>Product Page Form</h3>
      </div>
    </div>
    <form>
      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Thumbnail for desktop</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img v-if="form.thumbnail_for_desktop.url != ''" :src="form.thumbnail_for_desktop.url" alt=""
              class="img-thumbnail" />
          </div>
        </div>
        <div class="col-md-7">
          <!-- <SelectThumbnail v-model="medias" :selected="{}" :medias="medias" @searchMedias="searchMedias"></SelectThumbnail> -->
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ thumbnail</label>
            <searchbox @searchButtonClick="seachDesktopThumbnail"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="thumbnails_for_desktop" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectImageForDesktop">
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>

      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Thumbnail for mobile</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img v-if="form.thumbnail_for_mobile.url != ''" :src="form.thumbnail_for_mobile.url" alt=""
              class="img-thumbnail" />
          </div>
        </div>
        <div class="col-md-7">
          <!-- <SelectThumbnail v-model="medias" :selected="{}" :medias="medias" @searchMedias="searchMedias"></SelectThumbnail> -->
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ thumbnail</label>
            <searchbox @searchButtonClick="seachMobileThumbnail"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="thumbnails_for_mobile" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectImageForMobile">
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>

      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">ข้อมูลทั่วไป</h3>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="post_status">สถานะ *</label>
            <select class="form-control" v-model="form.status" name="status_select">
              <option></option>
              <option :value="'published'">published</option>
              <option :value="'draft'">draft</option>
              <option :value="'disabled'">disabled</option>
              <option :value="'trash'">trash</option>
            </select>
            <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label for="post_slug required">ชนิด *</label>
            <input type="text" class="form-control" v-model="form.post_type" disabled>
            <span v-if="errors['slug']" class="text-danger">{{ errors['slug'][0] }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="post_status">รูปแบบ *</label>
            <select class="form-control" name="page_type" v-model="form.format" :disabled="this.status === 'edit'">
              <option :value="'all_product'">{{ 'สินค้าทั้งหมด' }}</option>
              <option :value="'all_cate_2_filter'">{{ 'สินค้าทุกหมวด + 2 filter' }}</option>
              <option :value="'cate_1_filter'">{{ 'หมวดหมู่สินค้า + 1 filter' }}</option>
            </select>
            <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
          </div>
        </div>
      </div>


      <div v-if="form.format === 'all_product'">
        <div v-if="this.status !== 'edit'">
          <!-- Your code here -->
        </div>
      </div>
      <div v-else-if="form.format === 'all_cate_2_filter'">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="post_filter1">{{ 'ชนิดของ filter' }}</label>
              <select class="form-control" name="type_slug_lv1" v-model="form.type_slug_lv1" @change="updatePrioritySlugLv1"
                :disabled="this.status === 'edit'">
                <option :value="'default'">{{ 'โปรดระบุชนิดของ filter' }}</option>
                <option v-for="type_of_filter in all_type_filter.filter(item => item.type !== 'ประเภทพวงหรีด' && item.type !== 'ชนิดดอกไม้')"
                  :value="type_of_filter.type" :priority_slug_lv1="type_of_filter.priority">{{ type_of_filter.type }}
                </option>
              </select>
              <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="post_filter1">{{ 'ค่าของ filter' }}</label>
              <select class="form-control" name="slug_lv1"v-model="form.slug_lv1" :disabled="this.status === 'edit'">
                <option :value="'no_slug'">{{ 'ไม่ระบุ filter' }}</option>
                <option :value="'พวงหรีดราคาพิเศษ'" :hidden="form.slug_lv1 != 'พวงหรีดราคาพิเศษ'">{{ 'พวงหรีดราคาพิเศษ' }}</option>
                <option v-for="filter in all_filter.filter(item => item.type === form.type_slug_lv1)"
                  :value="filter.value" :id="filter.id">{{ filter.value }}</option>
              </select>
              <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="post_filter1">{{ 'ชนิดของ filter' }}</label>
              <select class="form-control" name="type_slug_lv2" v-model="form.type_slug_lv2" :disabled="this.status === 'edit'">
                <option :value="'default'">{{ 'โปรดระบุชนิดของ filter' }}</option>
                <option
                  v-for="type_of_filter in all_type_filter.filter(item => item.type !== 'ประเภทพวงหรีด' && item.type !== 'ชนิดดอกไม้' && item.priority > form.priority_slug_lv1)"
                  :value="type_of_filter.type" :disabled="type_of_filter.priority <= form.priority_slug_lv1">
                  {{ type_of_filter.type }}
                </option>
              </select>
              <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="post_filter2">{{ 'ค่าของ filter' }}</label>
              <select class="form-control" name="slug_lv2" v-model="form.slug_lv2" :disabled="this.status === 'edit'">
                <option :value="'no_slug'">{{ 'ไม่ระบุ filter' }}</option>
                <option v-for="filter in all_filter.filter(item => item.type === form.type_slug_lv2)"
                  :value="filter.value" :id="filter.id">{{ filter.value }}</option>
              </select>
              <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
            </div>
          </div>

        </div>
      </div>
      <div v-else-if="form.format === 'cate_1_filter'">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="post_filter1">{{ 'ชนิดของ filter' }}</label>
              <select class="form-control" name="type_slug_lv1" v-model="form.type_slug_lv1" @change="updatePrioritySlugLv1" :disabled="this.status === 'edit'">
                <option :value="'default'">{{ 'โปรดระบุชนิดของ filter' }}</option>
                <option :value="'ประเภทพวงหรีด'">{{ 'category' }}</option>
              </select>
              <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="post_filter1">{{ 'ค่าของ filter' }}</label>
              <select class="form-control" name="slug_lv1" v-model="form.slug_lv1" :disabled="this.status === 'edit'">
                <option :value="'no_slug'">{{ 'ไม่ระบุ filter' }}</option>
                <option v-for="filter in all_filter.filter(item => item.type === form.type_slug_lv1)"
                  :value="filter.value" :id="filter.id">{{ filter.value }}</option>
              </select>
              <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="post_filter1">{{ 'ชนิดของ filter' }}</label>
              <select class="form-control" name="type_slug_lv2" v-model="form.type_slug_lv2" :disabled="this.status === 'edit'">
                <option :value="'default'">{{ 'โปรดระบุชนิดของ filter' }}</option>
                <option
                  v-for="type_of_filter in all_type_filter.filter(item => item.type !== 'ประเภทพวงหรีด' && item.type !== 'ชนิดดอกไม้' && item.priority > form.priority_slug_lv1)"
                  :value="type_of_filter.type" :disabled="type_of_filter.priority <= form.priority_slug_lv1">
                  {{ type_of_filter.type }}
                </option>
              </select>
              <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="post_filter2">{{ 'ค่าของ filter' }}</label>
              <select class="form-control" name="slug_lv2" v-model="form.slug_lv2" :disabled="this.status === 'edit'">
                <option :value="'no_slug'">{{ 'ไม่ระบุ filter' }}</option>
                <option v-for="filter in all_filter.filter(item => item.type === form.type_slug_lv2)"
                  :value="filter.value" :id="filter.id">{{ filter.value }}</option>
              </select>
              <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
            </div>
          </div>

        </div>
      </div>


      <div class="row">
        <div class="col-md-12 mt-4">
          <div class="row">
            <div class="col-md-12">
              <h3 class="text text-secondary">เนื้อหาในแต่ละภาษา *</h3>
              <div class="text-danger">(* จะต้องใส่ข้อมูลใน H1 และ Title สำหรับ th-TH และ en-UK
                ก่อนจึงจะสามารถบันทึกได้)</div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ul class="nav nav-tabs">
                <li class="nav-item" v-for="(language, langIdx) in form.languages" :key="langIdx">
                  <a class="nav-link" href="javascript:void(0);" @click="languageTabClicked(langIdx)"
                    v-bind:class="{ active: form.languages[langIdx].clicked }">
                    {{ language.name }} ({{ language.code }})

                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="row pt-1">
            <div class="col-md-12 p-4">
              <div class="tab-content">
                <div class="tab-pane" v-for="(language, langIdx) in form.languages" :key="language.id"
                  v-bind:class="{ active: form.languages[langIdx].clicked }" :id="'language_content_' + langIdx">
                  <div class="row">
                    <div class="col-md-12">
                      <p>
                        เนื้อหาในภาษา {{ language.name }} ({{ language.code }})
                      </p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Topic(H1) *</label>
                        <input default="H1" type="text" name="product_page_h1" class="form-control" v-model="language.h1" />
                        <span v-if="errors['languages.' + langIdx + '.h1']" class="text-danger">{{ errors['languages.' +
                          langIdx + '.h1'][0] }}</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Excerpt</label>
                        <input type="text" class="form-control" name="product_page_excerpt" v-model="language.excerpt" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>title *</label>
                        <input type="text" class="form-control" name="product_page_title" v-model="language.title" />
                        <span v-if="errors['languages.' + langIdx + '.title']" class="text-danger">{{
                          errors['languages.' + langIdx + '.title'][0] }}</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>description</label>
                        <textarea type="text" class="form-control" name="product_page_description" v-model="language.meta_description"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:title</label>
                        <input type="text" class="form-control" name="product_page_ogtitle" v-model="language.og_title" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:description</label>
                        <textarea type="text" class="form-control" name="product_page_ogdescription" v-model="language.og_description"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>meta keyword</label>
                        <input type="text" class="form-control" name="product_page_meta_keyword" v-model="language.meta_keyword" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:site_name</label>
                        <input type="text" class="form-control" name="product_page_ogsitename" v-model="language.og_sitename" />
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>canonical</label>
                        <input type="text" class="form-control" v-model="language.canonical" />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>link_rel_alternate_hreflang</label>
                        <input type="text" class="form-control" v-model="language.link_rel_alternate_hreflang" />
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label>og:url</label>
                        <input type="text" class="form-control" v-model="language.og_url" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image_width</label>
                        <input type="text" class="form-control" v-model="language.og_image_width" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image_height</label>
                        <input type="text" class="form-control" v-model="language.og_image_height" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image</label>
                        <input type="text" class="form-control" name="product_page_ogimage"v-model="language.og_image" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image_type</label>
                        <input type="text" class="form-control" v-model="language.og_image_type" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>twitter:site</label>
                        <input type="text" class="form-control" v-model="language.twitter_site" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>twitter:domain</label>
                        <input type="text" class="form-control" v-model="language.twitter_domain" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>twitter:card</label>
                        <input type="text" class="form-control" v-model="language.twitter_card" />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>twitter:creator</label>
                        <input type="text" class="form-control" v-model="language.twitter_creator" />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>twitter:title</label>
                        <input type="text" class="form-control" v-model="language.twitter_title" />
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>structured data</label>
                    <textarea row="6" type="text" class="form-control" v-model="language.structured_data"></textarea>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs">
                            <li class="nav-item" v-for="(
                                contentPart, partIdx
                              ) in language.language_parts" :key="partIdx">
                              <a :href="'#' + 'language_part_' + partIdx" class="nav-link" @click="
                                onContentPartTabClicked(
                                  langIdx,
                                  partIdx,
                                  $event
                                )
                                " v-bind:class="{ active: contentPart.clicked }">
                                {{ partIdx == 0 ? 'ส่วนบนของหน้าเว็บ' : 'ส่วนล่างของหน้าเว็บ' }}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="tab-content">
                            <div class="tab-pane" v-for="(
                                contentPart, partIdx
                              ) in language.language_parts" :key="partIdx"
                              v-bind:class="{ active: contentPart.clicked }">
                              <div class="row">
                                <div class="col-md-12 text text-secondary">
                                  เนื้อหา {{ language.code }} ส่วน
                                  {{ partIdx == 0 ? 'บนของหน้าเว็บ' : 'ล่างของหน้าเว็บ' }}
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-12">
                                  <iframe :id="'iframe_language_' +
                                    language.id +
                                    '_part_' +
                                    partIdx
                                    " :src="base_url +
                                      '/' +
                                      item_id +
                                      '/language/' +
                                      language.id +
                                      '/' +
                                      partIdx +
                                      '/' +
                                      (form.languages[langIdx].language_parts[
                                        partIdx
                                      ].content == ''
                                        ? 'n'
                                        : 'y')
                                      " height="870px" width="100%" type="application/html" frameborder="0"
                                    scrolling="no" font-family="IBM Plex Sans Thai, sans-serif"></iframe>
                                  <!-- <input type="hidden" :id="'input_language_'+language.id+'_part_'+partIdx"
                                                                        v-model="form.languages[langIdx].language_parts[partIdx].content"
                                                                    > -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group float-right">
            <a href="javascript:void(0)" onclick="javascript:window.history.back(); return false;"
              class="btn btn-secondary">ยกเลิก</a>
            <button type="button" name="submit_button_without_more" lass="btn btn-primary ml-5" @click="saveWithGoBack()">
              บันทึก
            </button>
            <button type="button" name="submit_with_more" v-if="!this.item_id" class="btn btn-primary ml-5" @click="saveWithMore()">
              บันทึก และ บันทึกเพิ่ม
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</template>

<script>
//https://www.npmjs.com/package/vue-search-select

// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

// import { VueEditor, Quill } from 'vue2-editor' //https://npm.io/package/vue2-quill-editor
// import { ImageResize } from 'quill-image-resize-module';
// import htmlEditButton from "quill-html-edit-button"; //เพื่อใช้ HTML view button ตอนนี้ปิดไว้ก่อน
// import QuillBetterTable from 'quill-better-table' //เพื่อใช้ table ร่วมกับ vue2-editor ตอนนี้ปิดไว้ก่อน โหลดแล้วมีปัญหา

// Quill.register({'modules/ImageResize':ImageResize,'modules/htmlEditButton':htmlEditButton});

// import SelectThumbnail from './selectThumbnail'

import VueSelectImage from "vue-select-image"; //https://npm.runkit.com/vue-select-image สำหรับเลือกภาพ thumbnail
require("vue-select-image/dist/vue-select-image.css");

import searchbox from "../_layouts/searchbox.vue";
import axios from "axios";

export default {
  props: {
    item_id: "", //เก็บ id ของ cms กรณีที่เป็นการแก้ไข
  },
  components: {
    // VueEditor,
    // SelectThumbnail,
    // htmlEditButton,
    VueSelectImage,
    searchbox,
  },
  data() {
    return {
      form: {
        thumbnail_for_desktop: { id: "", url: "", mime_type: "" },
        thumbnail_for_mobile: { id: "", url: "", mime_type: "" },
        post_type: "product_category",
        comment_status: "disallow",
        status: "draft",
        format: "all_product",
        type_slug_lv1: "default",
        type_slug_lv2: "default",
        priority_slug_lv1: 0,
        slug_lv1: "no_slug",
        slug_lv2: "no_slug",
        slug_cate: "category",
        languages: [
          {
            h1: "",
            canonical: "",
            excerpt: "",
            title: "",
            meta_description: "",
            og_title: "",
            og_description: "",
            meta_keyword: "",
            site_name: "",
            og_image: "",
            og_image_type: "",
            og_image_height: "",
            og_image_width: "",
            og_url: "",
            og_locale: "",
            twitter_card: "",
            twitter_creator: "",
            twitter_title: "",
            twitter_site: "",
            twitter_domain: "",
            link_rel_alternate_hreflang: "",
            structured_data: "",
            language_id: "",
          }
        ],
      },
      validateError: {
        // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ
        slug: { error: false, message: "" },
        // post_type: { error: false, message: "" },
        comment_status: { error: false, message: "" },
        status: { error: false, message: "" },
        languages: { error: false, message: "" },
        thumbnail: { error: false, message: "" },
        // title: { error: false, message: "" },
        // h1: { error: false, message: "" },
      },
      errors: {},
      languages: [
        { title: '', h1: '' },
        { title: '', h1: '' },
        { title: '', h1: '' },
      ],
      content: "",
      editorOption: {
        modules: {
          htmlEditButton: { buttonHTML: "HTML" },
          ImageResize: { displaySize: true },
          toolbar: [
            // [{ 'font': ['','Prompt','Serif','Tahoma', 'Times-new-roman', 'Arial','Monospace']  }],
            [{ font: [] }],
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["link", "image"], // link and image
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"], // remove formatting button
          ],
        },
        placeholder: "ใส่เนื้อหาที่นี่",
        theme: "snow",
        height: "400",
      },
      all_filter: [],
      all_type_filter: [],
      medias: [], //thumbnail
      languages: [],
      status: "",

      base_url: "/product_page", // base url (เปลี่ยน)

      thumbnails_for_desktop: [],
      thumbnails_for_mobile: []
    };
  },
  mounted() {
    //console.log('Component mounted.')
  },
  created() {
    this.fetchCategories();
    this.fetchLanguages();
    
  },
  methods: {
    load() {
      axios
        .get(this.base_url + "/" + this.item_id)
        .then((response) => {
          let product_page = response.data;
          if (product_page.metas) {
            const thumbnailForDesktop = product_page.metas.find(meta => meta.meta_key === 'thumbnail_for_desktop');
            const thumbnailForMobile = product_page.metas.find(meta => meta.meta_key === 'thumbnail_for_mobile');
            if (thumbnailForDesktop) {
              this.form.thumbnail_for_desktop = {
                id: thumbnailForDesktop.id,
                url: thumbnailForDesktop.meta_value,
                mime_type: ''
              };
            } else {
              this.form.thumbnail_for_desktop = { id: "", url: "", mime_type: "" };
            }
            if (thumbnailForMobile) {
              this.form.thumbnail_for_mobile = {
                id: thumbnailForMobile.id,
                url: thumbnailForMobile.meta_value,
                mime_type: ''
              };
            } else {
              this.form.thumbnail_for_mobile = { id: "", url: "", mime_type: "" };
            }
          } else {
            this.form.thumbnail_for_desktop = { id: "", url: "", mime_type: "" };
            this.form.thumbnail_for_mobile = { id: "", url: "", mime_type: "" };
          }

          if (product_page.metas) {
            const meta_format = product_page.metas.find(meta => meta.meta_key === 'format');
            if (meta_format && (meta_format.meta_value === 'all_product' || meta_format.meta_value === 'all_cate_2_filter' || meta_format.meta_value === 'cate_1_filter')) {
              if (meta_format.meta_value === 'all_cate_2_filter' || meta_format.meta_value === 'cate_1_filter') {
                this.form.format = meta_format.meta_value;
                const meta_type_slug_lv2 = product_page.metas.find(meta => meta.meta_key === 'type_slug_lv2');
                const meta_type_slug_lv1 = product_page.metas.find(meta => meta.meta_key === 'type_slug_lv1');
                if (meta_type_slug_lv2 && meta_type_slug_lv1) {
                  const meta_slug_lv2 = product_page.metas.find(meta => meta.meta_key === 'slug_lv2');
                  const meta_slug_lv1 = product_page.metas.find(meta => meta.meta_key === 'slug_lv1');
                 
                  this.form.type_slug_lv2 = meta_type_slug_lv2.meta_value;
                  this.form.type_slug_lv1 = meta_type_slug_lv1.meta_value;
                  if(meta_slug_lv1 && meta_slug_lv2){
                    this.form.slug_lv2 = meta_slug_lv2.meta_value;
                    this.form.slug_lv1 = meta_slug_lv1.meta_value;
                  } else if(meta_slug_lv1){
                    this.form.slug_lv2 = "no_slug";
                    this.form.slug_lv1 = meta_slug_lv1.meta_value;
                  } else {
                    this.form.slug_lv1 = "no_slug";
                    this.form.slug_lv2 = "no_slug";
                  }
                  // Your code for handling meta_slug_lv2 and meta_slug_lv1
                } else {
                  const meta_slug_lv1 = product_page.metas.find(meta => meta.meta_key === 'slug_lv1');
                  this.form.type_slug_lv1 = meta_type_slug_lv1.meta_value;
                  this.form.slug_lv1 = meta_slug_lv1.meta_value;
                }
              }
            }
          }
          // this.form.thumbnail = cms.thumbnail.id ? {id:cms.thumbnail.id, url:cms.thumbnail.url} : {id:'', url:''};
          this.form.comment_status = product_page.comment_status;
          this.form.post_type = product_page.post_type;
          this.form.status = product_page.status;

          //ดึง content ในแต่ละภาษา และ ในแต่ละส่วนของภาษา
          product_page.languages.forEach((language, idx) => {
            this.form.languages[idx].h1 = language.h1 ? language.h1 : language.title;
            this.form.languages[idx].canonical = language.canonical ? language.canonical : '/ร้านพวงหรีด/';

            this.form.languages[idx].excerpt = language.excerpt ? language.excerpt : language.meta_description;
            this.form.languages[idx].title = language.title;
            this.form.languages[idx].meta_description = language.meta_description;
            this.form.languages[idx].og_title = language.og_title ? language.og_title : language.title;
            this.form.languages[idx].og_description = language.og_description ? language.og_description : language.meta_description;
            this.form.languages[idx].meta_keyword = language.meta_keyword;
            this.form.languages[idx].og_sitename = language.og_sitename ? language.og_sitename : "@wreathmala";
            // this.form.languages[idx].og_locale = language.og_locale ? language.og_locale : language.code; // language.code undefined
            this.form.languages[idx].twitter_card = language.twitter_card ? language.twitter_card : "summary";
            this.form.languages[idx].twitter_creator = language.twitter_creator ? language.twitter_creator : "@wreathmala";
            this.form.languages[idx].twitter_title = language.twitter_title ? language.twitter_title : language.title;
            this.form.languages[idx].twitter_site = language.twitter_site ? language.twitter_site : "https://www.wreathmala.com/";
            this.form.languages[idx].twitter_domain = language.twitter_domain ? language.twitter_domain : "https://www.wreathmala.com/";

            //get slug from condition of category
            this.form.languages[idx].og_url = "ร้านพวงหรีด/"; //language.og_url ? language.og_url : language.language_id == "1" ? this.form.slug + "/" : "/en/" + this.form.slug + "/";
            this.form.languages[idx].og_image = language.og_image ? language.og_image : this.form.thumbnail_for_desktop.url;
            this.form.languages[idx].og_image_type = language.og_image_type ? language.og_image_type : this.form.thumbnail_for_desktop.mime_type;
            this.form.languages[idx].og_image_height = language.og_image_height ? language.og_image_height : 630;
            this.form.languages[idx].og_image_width = language.og_image_width ? language.og_image_width : 1200;
            this.form.languages[idx].link_rel_alternate_hreflang = language.link_rel_alternate_hreflang ? language.link_rel_alternate_hreflang : language.language_id == "1" ? "/ร้านพวงหรีด/" : "/en/ร้านดอกไม้/";
            this.form.languages[idx].structured_data = language.structured_data ? language.structured_data : "";

            // console.log(language.language_parts);
            language.language_parts.forEach((part, idy) => {
              // console.log(part);
              if (idy > 1) {
              } else {
                this.form.languages[idx].language_parts[idy].content =
                  part.content;
              }
            });
            console.log("this.form.languages", this.form.languages);
            console.log("language", language);

          });

          // console.log(this.form);
        })
        .catch((errors) => {
          alert("loading Error", errors);
          console.log(errors);
        });
    },
    saveWithGoBack() {
      this.save("");
    },
    saveWithMore() {
      this.save("more");
    },
    save(whatNext) {
      console.log("I'm hear");
      let save_url = "";

      //เอา content จาก summernote ใน iframe ของแต่ละภาษา และ แต่ละ part ของภาษาเข้าไปใส่ใน this.form.languages
      this.get_language_from_ifram();

      if (this.item_id != "") {
        save_url = this.base_url + "/" + this.item_id + "/update";
      } else {
        save_url = this.base_url;
      }
      
      let me = this;
      this.form.thumbnail_for_desktop.url = this.form.thumbnail_for_desktop.url ? this.form.thumbnail_for_desktop.url : "https://appbit-storage.s3.ap-southeast-1.amazonaws.com/dev/2024/10/o0piUzZzHOoUpD4smcnrqaWiM4U3Fa4EdegPiZau.webp"; 

      this.form.type_slug_lv2 = this.form.type_slug_lv2 == "default" ? "" : this.form.type_slug_lv2;
      this.form.slug_lv2 = this.form.slug_lv2 == "no_slug" ? "" : this.form.slug_lv2;

      console.log("this.form", this.form); //return;
      axios
        .post(save_url, this.form)
        .then((response) => {
          console.log("response", response);
          response.status == "200"
            ? whatNext == "more"
              ? window.location.href = this.base_url + "/form"
              : window.location.href = this.base_url
            : alert("Error Status:", response.status);
        })
        .catch((error) => {
          console.log("error.response:", error.response)
          if (error.response && error.response.status === 422) {
            this.errors = error.response.data.message;
          }
          console.log("errors:", this.errors);

        });
    },
    get_language_from_ifram() {
      let iframe = {};
      let iWindow = {};
      let iDocument = {};
      let element = {};
      this.languages.forEach((item, langIdx) => {
        for (let partIdx = 0; partIdx <= 1; partIdx++) {
          iframe = document.getElementById(
            "iframe_language_" + item.id + "_part_" + partIdx
          );
          iWindow = iframe.contentWindow;
          iDocument = iWindow.document;

          element = iDocument.getElementById("summernote_code");
          
          let cleanedContent = this.cleanHtml(element.value);

          this.form.languages[langIdx].language_parts[partIdx].content = cleanedContent;

        }
      });
    },
    fetchLanguages(url) {
      url = url || "/fetch/language";
      axios
        .get(url)
        .then((response) => {
          this.languages = response.data.items;
          // console.log("this.languages", this.languages);
          this.languages.forEach((item, idx) => {
            this.languages[idx].title = "";
            this.languages[idx].excerpt = "";
            this.languages[idx].language_parts = [
              { id: 1, content: "", clicked: true },
              { id: 2, content: "", clicked: false },
            ];
          });
          this.form.languages = this.languages;
          console.log("this.form line 956", this.form);
          if (this.item_id) {
            this.status = "edit";
            this.load(); // load items ถ้ามีระบุ item_id มาจาก หน้า edit
          }
        })
        .catch((errors) => {
          alert("Unable to load Languge " + errors.message);
          console.log(errors);
        });
    },
    fetchCategories(url) {
      url = url || this.base_url + "/fetchCategories";
      axios
        .get(url)
        .then((response) => {
          this.all_type_filter = response.data.items.reduce((acc, item) => {
            const key = item.key;
            let priority = 0;
            if (key === "ประเภทพวงหรีด") {
              priority = 1;
            } else if (key === "ช่วงราคา") {
              priority = 2;
            } else if (key === "ขนาดพวงหรีด") {
              priority = 3;
            } else if (key === "สี") {
              priority = 4;
            }
            const existingItem = acc.find(i => i.type === key);
            if (!existingItem) {
              acc.push({ type: key, priority });
            }
            return acc;
            }, []).filter(item => !this.all_filter.some(filter => filter.type === item.type));
            
            this.all_filter = [
              {type: 'ช่วงราคา', id: '999', value: 'ราคาไม่แพง'},
              {type: 'ช่วงราคา', id: '998', value: 'ราคา-1500-2000'},
              {type: 'ช่วงราคา', id: '997', value: 'ราคา-2000-2500'},
              {type: 'ช่วงราคา', id: '996', value: 'ราคา-2500-3000'},
              {type: 'ช่วงราคา', id: '995', value: 'ราคา-3000-ขึ้นไป'},
              {type: 'ประเภทพวงหรีด', id: '994', value: 'พวงหรีดพัดลม-16-นิ้ว'},
              {type: 'ประเภทพวงหรีด', id: '993', value: 'พวงหรีดพัดลม-18-นิ้ว'},
              {type: 'ประเภทพวงหรีด', id: '992', value: 'พวงหรีดพัดลม-20-นิ้ว'},
              {type: 'ประเภทพวงหรีด', id: '991', value: 'พวงหรีดพัดลม-22-นิ้ว'},
              ...response.data.items.reduce((acc, item) => {
            const key = item.key;
            const existingItem = acc.find(i => i.key === key);
            if (existingItem) {
              existingItem.values.push({ type: key, id: item.id, value: item.value });
            } else if (key !== 'ช่วงราคา' && item.value !== 'พัดลม 16 นิ้ว' && item.value !== 'พัดลม 18 นิ้ว' && item.value !== 'พัดลม 20 นิ้ว' && item.value !== 'พัดลม 22 นิ้ว') {
              acc.push({ 
              type: key, 
              id: item.id, 
              value: item.value.startsWith('SIZE ') ? 'ขนาด-' + item.value.slice(5) : item.value 
              });
            }
            return acc;
            }, [])];
          console.log("this.all_filter", this.all_filter);
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    languageTabClicked(langIdx = 0) {
      console.log("langIdx", langIdx);
      this.form.languages.forEach((item, idx) => {
        this.form.languages[idx].clicked = false;
      });
      this.form.languages[langIdx].clicked = true;
    },
    onContentPartTabClicked(langIdx, partIdx) {
      this.languageTabClicked(langIdx);

      this.form.languages[langIdx].language_parts.forEach(function (part, y) {
        if (y == partIdx) {
          part.clicked = true;
        } else {
          part.clicked = false;
        }
      });
    },
    seachDesktopThumbnail(searchKeword) {
      this.thumbnails_for_desktop = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            this.thumbnails_for_desktop.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    seachMobileThumbnail(searchKeword) {
      this.thumbnails_for_mobile = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            this.thumbnails_for_mobile.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    onSelectImageForDesktop(data) {
      console.log(data);
      this.form.thumbnail_for_desktop.url = data.src;
      this.form.thumbnail_for_desktop.id = data.id;
    },
    onSelectImageForMobile(data) {
      console.log(data);
      this.form.thumbnail_for_mobile.url = data.src;
      this.form.thumbnail_for_mobile.id = data.id;
    },
    updatePrioritySlugLv1() {
      const type = this.form.type_slug_lv1;
      const typeFilter = this.all_type_filter.find(item => item.type === type);
      this.form.priority_slug_lv1 = typeFilter.priority;
    },
    cleanHtml(html) {
      if (!html) return "";
      let doc = new DOMParser().parseFromString(html, 'text/html');
      
      // Cleanup headings (h1-h6)
      let headings = doc.querySelectorAll("h1, h2, h3, h4, h5, h6");
      headings.forEach((heading) => {
        // Remove style and dir attributes from headings if they look like Google Docs artifacts
        heading.removeAttribute("dir");
        heading.style.marginTop = "";
        heading.style.marginBottom = "";
        heading.style.lineHeight = "";
        if (heading.getAttribute("style") === "") {
             heading.removeAttribute("style");
        }

        // Unwrap spans inside headings
        let spans = heading.querySelectorAll("span");
        spans.forEach((span) => {
          const parent = span.parentNode;
          while (span.firstChild) {
            parent.insertBefore(span.firstChild, span);
          }
          parent.removeChild(span);
        });
      });

      // Cleanup spans that might be wrappers from Google Docs (often with long IDs)
      let googleDocsSpans = doc.querySelectorAll("span[id^='docs-internal-guid-']");
      googleDocsSpans.forEach((span) => {
          const parent = span.parentNode;
          while (span.firstChild) {
            parent.insertBefore(span.firstChild, span);
          }
          parent.removeChild(span);
      });

      return doc.body.innerHTML;
    },
  },
};
</script>
<style scoped>
.ql-editor {
  max-height: 300px !important;
  min-height: 300px !important;
  overflow: auto;
}

#language_content_0 {
  background-color: #b0c4de;
  /* Active background color */
  color: black;
  padding: 20px;
}

#language_content_1 {
  background-color: #faebd7;
  /* Active background color */
  color: black;
  padding: 20px;
}
</style>